import script from "./ProgressItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProgressItem.vue?vue&type=script&setup=true&lang=ts"

import "./ProgressItem.vue?vue&type=style&index=0&id=03389271&scoped=true&lang=css"

import exportComponent from "/fides/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-03389271"]])

export default __exports__